import { API } from "services/enum/api";
import { fetcher } from "services/fetcher";
import useSWR from "swr";

type UsePartnerReturnType = {
  isLoading: boolean;
  data: Partner[];
  mutate: () => void;
  isValidating: boolean;
  error: any;
  [key: string]: any;
};

export function usePartners(): UsePartnerReturnType {
  const { data, mutate, error, isLoading, isValidating } = useSWR(API.GET_ALL_PARTNERS, fetcher);

  return {
    data: data?.data || [],
    isLoading,
    isError: error,
    isEmpty: !error && !isLoading && !data,
    mutate,
    isValidating,
    error,
  }
};
